import Vue from 'vue';
import Router from 'vue-router';

import Welcome from './views/Welcome.vue';
import Top from './views/Top.vue';
import Game from './views/Game.vue';
import Campaign from './views/Campaign.vue';
import Record from './views/Record.vue';
import Rule from './views/Rule.vue';
import Target from './views/Target.vue';
import Terms from './views/Terms.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/top/',
      name: 'top',
      component: Top
    },
    {
      path: '/terms/',
      name: 'terms',
      component: Terms
    },
    {
      path: '/target/',
      name: 'target',
      component: Target
    },
    {
      path: '/record/',
      name: 'record',
      component: Record
    },
    {
      path: '/rule/',
      name: 'rule',
      component: Rule
    },
    {
      path: '/game/',
      name: 'game',
      component: Game
    },
    {
      path: '/campaign/',
      name: 'campaign',
      component: Campaign
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
